import type { Bi } from './sectors'

// Homepage "Explorez la plateforme" index. Destinations are resolved from the
// shared navigation (data/navigation.ts) by id, so this section, the header
// menu and the footer always point to the same pages.

export type ExploreTile = { navId: string; label: Bi }
export type ExploreGroup = { id: 'foundation' | 'services' | 'intelligence'; label: Bi; tiles: ExploreTile[] }

export const exploreCopy = {
  eyebrow: { fr: 'Explorez la plateforme', en: 'Explore the platform' } as Bi,
  headline: [
    { fr: 'Une fondation.', en: 'One foundation.' },
    { fr: 'Des modules qui s’imbriquent.', en: 'Connected capabilities.' },
  ] as Bi[],
  link: { fr: 'Découvrir la plateforme complète', en: 'View the full platform' } as Bi,
}

export const exploreGroups: ExploreGroup[] = [
  {
    id: 'foundation',
    label: { fr: 'Fondation', en: 'Foundation' },
    tiles: [
      { navId: 'overview', label: { fr: 'Vue d’ensemble', en: 'Platform overview' } },
      { navId: 'identity', label: { fr: 'Identité', en: 'Identity' } },
      { navId: 'digital-card', label: { fr: 'Carte numérique', en: 'Digital Card' } },
      { navId: 'digital-experience', label: { fr: 'Expérience numérique', en: 'Digital experience' } },
    ],
  },
  {
    id: 'services',
    label: { fr: 'Services et opérations', en: 'Services & operations' },
    tiles: [
      { navId: 'communications', label: { fr: 'Communications', en: 'Communications' } },
      { navId: 'requests', label: { fr: 'Requêtes', en: 'Requests' } },
      { navId: 'collect', label: { fr: 'Collectes', en: 'Waste collection' } },
      { navId: 'permits', label: { fr: 'Permis', en: 'Permits' } },
      { navId: 'recreation', label: { fr: 'Loisirs', en: 'Recreation' } },
      { navId: 'pet-licensing', label: { fr: 'Médailles et licences', en: 'Pet tags & licences' } },
      { navId: 'smart-water', label: { fr: 'Compteurs d’eau', en: 'Smart Water' } },
    ],
  },
  {
    id: 'intelligence',
    label: { fr: 'Intelligence', en: 'Intelligence' },
    tiles: [{ navId: 'atna', label: { fr: 'ATNA', en: 'ATNA' } }],
  },
]
